import React, { Component } from 'react'
import { ItemData } from '../apis/item.api'
import ContentAside from '../components/ContentAside'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import ShipOrderEditForm from '../partials/ShipOrderEditForm'
import ItemCard from '../components/ItemCard'
import ItemQuantityList from '../partials/ItemQuantityList'

interface ShipOrderEditProps {}

interface ShipOrderEditState {
  item: ItemData | null
  quantity: number
}

export default class ShipOrderEdit
  extends Component<ShipOrderEditProps, ShipOrderEditState> {
  constructor (props: ShipOrderEditProps) {
    super(props)
    this.state = {
      item: null,
      quantity: 0
    }
    this.handleItemChange = this.handleItemChange.bind(this)
  }

  get aside () {
    const { item, quantity } = this.state
    return item &&
      <div className='flex gap-5 flex-col'>
        <ItemCard
          code={item.code}
          description={item.description}
          cpp={item.cpp}
          qpc={item.qpc} />
        <ItemQuantityList
          heading='Shipping total calculation'
          item={item}
          quantity={quantity} />
      </div>
  }

  handleItemChange (item: ItemData | null) {
    this.setState({ item })
  }

  handleQuantityChange = (quantity: number) => {
    this.setState({ quantity })
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <ShipOrderEditForm
            onItemChange={this.handleItemChange}
            onQuantityChange={this.handleQuantityChange} />
        </ContentMain>
        <ContentAside layout="oneThird">
          {this.aside}
        </ContentAside>
      </ContentLayout>
    )
  }
}
